export default __webpack_public_path__ + "static/media/hide.ac4c5437.svg";